import { path as financialPath } from "../../financial/path";

import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const withdrawRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.withdraw.route,
      lazy: () =>
        import(
          "@pages/panelPages/financialManagements/walletBalance/withdraw/withdraw"
        ),
      loader: ({ request }) => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.financialManagements.withdraw",
          [
            {
              title: "pageTitle.patientWallet",
              url: financialPath.wallet.link(),
            },
          ],
          "index",
        );
        return {};
      },
    },
    permissions: ["patient", "inactive-patient"],
  },
];
